<template>
  <!-- Reminder Block -->
  <div class="row no-gutters justify-content-center bg-primary-dark-op">
    <div class="hero-static col-sm-8 col-md-6 col-xl-4 d-flex align-items-center p-2 px-sm-0">
      <div class="block block-transparent block-rounded w-100 mb-0 overflow-hidden">
    <div class="block-content block-content-full px-lg-5 px-xl-6 py-4 py-md-5 py-lg-6 bg-white">
      <!-- Header -->
      <div class="mb-2 text-center">
        <router-link :to="{ name: 'welcome' }" class="link-fx font-w700 font-size-h1" href="index.html">
          <span class="text-dark">{{$t('auth.pwReset.' + selectedChain)}}</span><span class="text-primary"> {{$t('auth.pwReset.detective')}}</span>
        </router-link>
        <p class="text-uppercase font-w700 font-size-sm text-muted">{{$t('auth.pwReset.passwordReminder')}}</p>
      </div>
      <!-- END Header -->

      <!-- Reminder Form -->
      <form @submit.prevent="sendPwResetEmail">
        <div class="form-group">
          <div class="input-group">
            <input v-model="email" type="email" class="form-control" id="reminder-credential" name="reminder-credential" :placeholder="$t('auth.pwReset.email')">
            <div class="input-group-append">
              <span class="input-group-text">
                  <i class="fa fa-envelope-open"></i>
              </span>
            </div>
          </div>
        </div>
        <div v-show="success" class="alert alert-success alert-dismissable" role="alert">
          <button @click="success = ''" type="button" class="close" aria-label="Close">
            <span aria-hidden="true">×</span>
          </button>
          <p v-text="success" class="mb-0"></p>
        </div>
        <div v-show="error" class="alert alert-danger alert-dismissable" role="alert">
          <button @click="error = ''" type="button" class="close" aria-label="Close">
            <span aria-hidden="true">×</span>
          </button>
          <p v-text="error" class="mb-0"></p>
        </div>
        <div class="form-group text-center">
          <button type="submit" class="btn btn-hero-primary mt-2" :disabled="loading">
            <font-awesome-icon v-if="!loading" icon="reply" fixed-width class="mr-1"/><font-awesome-icon v-else icon="spinner" fixed-width class="mr-1 fa-spin"/> {{$t('auth.pwReset.resetPassword')}}
          </button>
        </div>
      </form>
      <div class="col-md-12 text-center">
        <router-link :to="{ name: 'login' }">Go back to Login</router-link>
      </div>
      <!-- END Reminder Form -->
    </div>
  </div>
    </div>
  </div>
  <!-- END Reminder Block -->
</template>

<script>
const fb = require('@/firebaseConfig.js')

export default {
  name: 'pwreset',
  data () {
    return {
      email: '',
      loading: false,
      success: '',
      error: ''
    }
  },
  computed: {
    selectedChain () {
      return this.$store.state.options.selectedChain
    }
  },
  methods: {
    sendPwResetEmail () {
      this.loading = true
      fb.auth.sendPasswordResetEmail(this.email)
        .then(() => {
          this.success = this.$t('auth.verifyEmail.emailSuccessfullySent')
          this.loading = false
        })
        .catch((error) => {
          this.error = error.message
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>

</style>
